import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { 
  ListRequestedSupplierStatesRequest, ListRequestedSupplierStatesResponse, ProductName, RequestedSupplier, SituViewWebApiClient, StyleConfigTemplate
} from 'situview-webapi-client';
import { AuthService, StateService } from 'src/app/services';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';

@Component({
  selector: 'requested-supplier-list',
  templateUrl: './requested-supplier-list.component.html',
  styleUrls: ['./requested-supplier-list.component.less']
})
export class RequestedSupplierListComponent extends SituBaseComponent {
  loading: boolean = false;
  data = new MatTableDataSource<RequestedSupplier>();
  searchTerm = "";
  productNames = ProductName;
  productName: ProductName | undefined;
  isHidden: boolean | undefined;
  globalOnly: boolean | undefined;

  constructor(
    authService: AuthService,
    stateService: StateService,
    private router: Router,
    private snackBar: MatSnackBar,
    private situViewApiClient: SituViewWebApiClient
  ) { 
    super(authService, stateService);
  }

  protected onSelectedCompanyChange(): void {
    this.loadData();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onClickStyleTemplate(item: StyleConfigTemplate) {
    this.router.navigate(['admin/style-template', item.id]);
  }

  setProductName(productName: ProductName) {
    this.productName = productName;
    this.loadData();
  }
  
  setIsHidden(isHidden: boolean) {
    this.isHidden = isHidden;
    this.loadData();
  }
  
  setGlobalOnly(globalOnly: boolean) {
    this.globalOnly = globalOnly;
    this.loadData();
  }

  loadData() {
    this.loading = true;

    let request = new ListRequestedSupplierStatesRequest();

    this.situViewApiClient.listRequestedSupplierStates(request)
      .then((response: ListRequestedSupplierStatesResponse) => {
        if (response.success) {
          this.data.data = response.requestedSuppliers ?? [];
        } else {
          this.showMessage("There was an issue retrieving style templates!");
        }
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
        this.showMessage("Could not retrieve style templates!");
      });
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}